<template lang="pug">
.contant-card
  h5.text-center 關於我們
  .border-hr
  .mt-4 
    p {{ profile.description }}
    span(v-for="contact in profile.contacts", :key="contact.id")
      span {{ contact.title }} : {{ contact.description }}
    span Email : {{ profile.email }}
    span 聯絡時間 : {{ profile.contact_time }}
    span 聯絡電話 : {{ profile.phone }}
</template>

<script>
import { getCompanyProfile } from "@/api/web_content";

export default {
  name: "AboutUs",
  data() {
    return {
      profile: {
        address: "",
        description: "",
        email: "",
        phone: "",
        contacts: [],
        contact_time: "",
      },
    };
  },
  created() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      getCompanyProfile().then((response) => {
        this.profile = response.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
p,
span {
  color: $c-text;
  letter-spacing: 1px;
  font-size: 16px;
  line-height: 30px;
}

p {
  margin-bottom: 20px;
}

span {
  display: block;
}
</style>
